<script>
// import Layout from "@/core/layouts/main";
import appConfig from "@/app.config";
import { Modal } from "bootstrap";
// import PageHeader from "@/core/components/page-header";
// import store from "@/state/store";
// var state = store._modules.root._children.auth.state;
export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    // Layout,
    // PageHeader,
  },
  data() {
    return {
      HrAwards: [],
      page: 1,
      limit: 20,
      tot_pages: 0,
      searchHrAwards: null,
      HrAwardsSearchMode: false,
      searchModel: "",
      hr_custodies: [],
      add_custody_modal: {},
      fixed_asset_products: [],
      transfer_hr_custody_modal: {},
      emps: [],
      data: {},
      fixed_asset: {
        name: "",
        name_en: "",
      },
      reference_no: "",
      // state: state,
    };
  },
  methods: {
    search(page) {
      if (!this.searchModel.length > 0) this.cancelappsearchMode();
      this.HrAwardsSearchMode = true;
      this.tot_pages = 0;
      this.http
        .post("emp-custodies/by-emp-id/search", {
          search: this.searchModel,
          limit: this.limit,
          emp_id: this.$route.params.id,
          page,
          col: "name",
        })
        .then((res) => {
          this.hr_custodies = res.data;
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          console.log("######## files", this.HrAwards);
        });
    },
    cancelappsearchMode() {
      this.searchModel = "";
      this.HrAwardsSearchMode = false;
      this.get(1);
    },

    deleteHrCustody(app) {
      console.log(app);
      var data = {
        title: "hr_custodies.delete_custody",
        inputs: [
          {
            model: "reference_no",
            type: "text",
            label: "fixed_assets.reference_no",
          },
        ],
        buttons: [
          {
            text: "popups.release",
            closer: true,
            color: "primary",
            handler: (obj) => {
              console.log("###");
              this.http
                .delete("emp-custodies", app.id, {
                  reference_no: obj.reference_no,
                })
                .then(() => {
                  this.get(this.page);
                });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },

    get(page) {
      console.log(page);
      this.http
        .post("emp-custodies/by-emp-id/pagination", {
          limit: this.limit,
          page: page,
          emp_id: this.$route.params.id,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.hr_custodies = res.data;
        });
    },
    showLabel(one) {
      return (
        (this.$i18n.locale == "en" ? one?.name_en + " - " : one?.name + " - ") +
        one?.serial_no
      );
    },
    searchFixedAssets(search) {
      console.log("product :", this.product);

      this.http
        .post(
          "emp-custodies/search-fixed-asset-products",
          { search },
          null,
          true
        )
        .then((res) => {
          if (res.status) {
            this.fixed_asset_products = res.data;
          }
        });
    },
    openHrCustodiesModal() {
      this.fixed_asset = {
        name: "",
        name_en: "",
        serial_no: "",
      };
      this.reference_no = null;
      this.add_custody_modal.show();
    },
    addHrCustody() {
      this.http
        .post("emp-custodies", {
          fixed_asset_product_id: this.fixed_asset.id,
          emp_id: this.$route.params.id,
          reference_no: this.reference_no,
        })
        .then((res) => {
          if (res.status) {
            this.add_custody_modal.hide();
            this.get(1);
            this.reference_no = null;
          }
        });
    },

    transferHrCustody() {
      console.log("data :", this.data);

      this.http
        .put("emp-custodies/transfer-asset-custody", this.data.id, {
          reference_no: this.data.reference_no,
          emp: this.data.emp,
          fixed_asset_product: {
            id: this.data.fixed_asset_product_id,
            name: this.data.fixed_asset_name,
            name_en: this.data.fixed_asset_name_en,
            serial_no: this.data?.serial_no,
          },
        })
        .then((res) => {
          if (res.status) {
            this.popup.alert({
              title: "popups.done",
              msg: res.msg,
            });
            this.transfer_hr_custody_modal.hide();
            this.get(this.page);
          }
        });
    },
    openTransferHrCustodyModal(data) {
      this.data = Object.assign({}, data);
      this.transfer_hr_custody_modal.show();
    },
    searchEmployees(search) {
      this.http
        .post(
          "emp-custodies/search-emps",
          { search, limit: 25, current_emp_id: this.$route.params.id },
          null,
          true
        )
        .then((res) => {
          if (res.status) {
            this.emps = res.data;
          }
        });
    },
    showEmpLabel(one) {
      return one.name;
    },
  },
  mounted() {
    this.add_custody_modal = new Modal("#hrCustodyModal");
    this.transfer_hr_custody_modal = new Modal("#transferHrCustodyModal");
  },
  created() {
    this.get(1);
  },
};
</script>

<template>
  <!-- <Layout> -->
  <div class="row">
    <div class="col-6">
      <div class="search-box chat-search-box w-50">
        <div class="position-relative">
          <input
            @input="search(page)"
            type="search"
            class="form-control fa-lg text-light"
            :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
            :placeholder="$t('popups.search')"
            v-model="searchModel"
            style="background-color: #2a3042 !important"
          />
          <i class="bx bx-search-alt search-icon text-light"></i>
        </div>
      </div>
    </div>
    <div class="col-6" style="display: flex; justify-content: flex-end">
      <button
        type="button"
        @click="openHrCustodiesModal()"
        class="btn btn-light float-end mb-4"
      >
        <span
          class="bx bxs-plus-circle float-end fa-2x"
          style="color: #2a3042 !important"
        ></span>
      </button>
    </div>
  </div>

  <table :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" class="table">
    <thead>
      <tr
        class="text-light text-center"
        style="background-color: #2a3042 !important"
      >
        <th scope="col">{{ $t("fixed_assets.code") }}</th>

        <th scope="col">{{ $t("hr_custodies.fixed_asset") }}</th>
        <th scope="col">{{ $t("fixed_assets.serial_no") }}</th>

        <th scope="col">{{ $t("hr_custodies.operations") }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="app in hr_custodies" :key="app" class="text-center">
        <td>{{ app?.fixed_asset_code }}</td>
        <td>
          {{
            $i18n.locale == "en"
              ? app?.fixed_asset_name_en
              : app?.fixed_asset_name
          }}
        </td>
        <td>{{ app?.serial_no }}</td>

        <td class="action-section">
          <a
            class="btn btn-primary"
            href="javascript: void(0);"
            role="button"
            @click="openTransferHrCustodyModal(app)"
            >{{ $t("hr_custodies.transfer_custody") }}</a
          >
          <a
            class="btn btn-danger"
            href="javascript: void(0);"
            role="button"
            @click="deleteHrCustody(app)"
            >{{ $t("hr_custodies.delete_custody") }}</a
          >
        </td>
      </tr>
    </tbody>
  </table>
  <!-- end  table -->
  <!-- Button trigger modal -->

  <div>
    <ul class="pagination pagination-rounded justify-content-center mb-2">
      <li class="page-item" :class="{ disabled: page == 1 }">
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="this.search ? search(page - 1) : get(page - 1)"
          aria-label="Previous"
        >
          <i class="mdi mdi-chevron-left"></i>
        </a>
      </li>
      <li
        class="page-item"
        :class="{ active: p == page }"
        v-for="p in tot_pages"
        :key="p"
      >
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="this.search ? search(p) : get(p)"
          >{{ p }}</a
        >
      </li>

      <li class="page-item" :class="{ disabled: page == tot_pages }">
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="this.search ? search(page - 1) : get(page + 1)"
          aria-label="Next"
        >
          <i class="mdi mdi-chevron-right"></i>
        </a>
      </li>
    </ul>
  </div>

  <div
    class="modal fade"
    id="hrCustodyModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modelTitleId"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <form @submit.prevent="addHrCustody()">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ $t("hr_custodies.add_custody") }}
            </h5>
            <button
              type="button"
              class="close"
              @click="add_custody_modal.hide()"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label for="" class="form-label">{{
                $t("hr_custodies.fixed_asset")
              }}</label>
              <AutoComplete
                v-model="fixed_asset"
                :suggestions="fixed_asset_products"
                @complete="searchFixedAssets($event.query)"
                :complete-on-focus="true"
                :optionLabel="showLabel"
                class="w-100"
                :input-class="'form-control w-100'"
              />
            </div>
            <div class="mb-3">
              <label for="" class="form-label">{{
                $t("fixed_assets.reference_no")
              }}</label>
              <input type="text" class="form-control" v-model="reference_no" />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="this.add_custody_modal.hide()"
              class="btn btn-light"
            >
              {{ $t("popups.cancel") }}
            </button>
            <button
              :disabled="!fixed_asset.id"
              type="submit"
              class="btn btn-primary"
            >
              {{ $t("popups.add") }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!--end-->
  <!-- </Layout> -->

  <div
    class="modal fade"
    id="transferHrCustodyModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modelTitleId"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <form @submit.prevent="transferHrCustody()">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ $t("hr_custodies.search_emps") }}
            </h5>
            <button
              type="button"
              class="close"
              @click="transferHrCustodyModal.hide()"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label for="" class="form-label">{{
                $t("hr_custodies.emp_name")
              }}</label>
              <AutoComplete
                v-model="data.emp"
                :suggestions="emps"
                @complete="searchEmployees($event.query)"
                :complete-on-focus="true"
                :optionLabel="showEmpLabel"
                :inputClass="'form-control'"
                class="w-100"
              />
            </div>
            <div class="mb-3">
              <label for="" class="form-label">{{
                $t("fixed_assets.reference_no")
              }}</label>
              <input
                type="text"
                class="form-control"
                v-model="data.reference_no"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="this.transfer_hr_custody_modal.hide()"
              class="btn btn-light"
            >
              {{ $t("popups.cancel") }}
            </button>
            <button
              :disabled="!(data?.emp && data?.emp?.id)"
              type="submit"
              class="btn btn-primary"
            >
              {{ $t("popups.transfer") }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<style>
.action-section {
  gap: 10px;
  display: flex;
  justify-content: center;
}
.btn-close {
  position: relative;
  right: 317px;
  top: 6px;
  font-size: 15px;
}
/* 
.p-autocomplete {
    display: inline-flex;
    position: relative;
}

.p-autocomplete-loader {
    position: absolute;
    top: 50%;
    margin-top: -0.5rem;
}

.p-autocomplete-dd .p-autocomplete-input {
    flex: 1 1 auto;
    width: 1%;
}

.p-autocomplete-dd .p-autocomplete-input,
.p-autocomplete-dd .p-autocomplete-multiple-container {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.p-autocomplete-dd .p-autocomplete-dropdown {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0px;
}

.p-autocomplete .p-autocomplete-panel {
    min-width: 100%;
}

.p-autocomplete-panel {
    position: absolute;
    overflow: auto;
    top: 0;
    left: 0;
    background: #ffffff;
    color: #495057;
    border: 0 none;
    border-radius: 6px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.p-component {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    font-size: 1rem;
    font-weight: normal;
}

.p-autocomplete-items {
    margin: 0;
    padding: 0;
    list-style-type: none;
}

.p-autocomplete-item {
    cursor: pointer;
    white-space: nowrap;
    position: relative;
    overflow: hidden;
}

.p-autocomplete-multiple-container {
    margin: 0;
    padding: 0;
    list-style-type: none;
    cursor: text;
    overflow: hidden;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.p-autocomplete-token {
    cursor: default;
    display: inline-flex;
    align-items: center;
    flex: 0 0 auto;
}

.p-autocomplete-token-icon {
    cursor: pointer;
}

.p-autocomplete-input-token {
    flex: 1 1 auto;
    display: inline-flex;
}

.p-autocomplete-input-token input {
    border: 0 none;
    outline: 0 none;
    background-color: transparent;
    margin: 0;
    padding: 0;
    box-shadow: none;
    border-radius: 0;
    width: 100%;
}

.p-fluid .p-autocomplete {
    display: flex;
}

.p-fluid .p-autocomplete-dd .p-autocomplete-input {
    width: 1%;
}

.p-autocomplete-panel.p-component{
  z-index: 9999 !important;
} */
</style>
